<template>
  <div>
    <h2 class="view__title--sub">{{ L.localize("Campaign_TargetTitle") }}</h2>

    <AdvancedSearch
      @search="triggerListUpdate"
      :searchCriterias="searchCriterias"
      searchButtonLabel="Label_Apply"
    />

    <div class="message message--info">
      <div
        style="float: left; line-height: 53px;"
      >{{ pagination.totalCount }} {{ L.localize('Campaign_TargetCount') }}</div>
      <button
        v-if="members.length > 0"
        style="margin: 0;"
        class="button button--border button--right"
        v-on:click="showEmails = !showEmails"
      >
        <span class="button__label" v-if="!showEmails">{{ L.localize('Label_View')}}</span>
        <span class="button__label" v-else>{{ L.localize('Label_Hide')}}</span>
      </button>
    </div>

    <list v-if="showEmails" class="view__embedded-content" :data="entries" :fields="headers()" />
  </div>
</template>

<script>
import List from "components/layout/list";
import { mapGetters } from "vuex";
import AdvancedSearch from "components/views/members/AdvancedSearch";
import L from "services/Localization";

export default {
  name: "campaign-target",
  components: { List, AdvancedSearch },
  props: {
    campaign: {
      type: Object,
      required: true,
      default: []
    }
  },
  data() {
    return {
      L: L,
      searchCriterias: [],
      showEmails: false
    };
  },
  computed: {
    ...mapGetters({
      members: "allMembers",
      pagination: "allMembersPagination"
    }),

    entries() {
      let self = this;
      return this.members.map(function(member) {
        let url = self.$router.resolve({
          name: "member-detail",
          params: { id: member.id }
        });
        return _.assign(JSON.parse(member.data), {
          id: member.id,
          __url: url.href
        });
      });
    }
  },
  mounted() {
    this.searchCriterias = this.campaign.searchCriterias;
    this.refreshCount();
  },
  methods: {
    triggerListUpdate: function(searchCriterias) {
      this.campaign.searchCriterias = searchCriterias;
      this.refreshCount();
    },
    refreshCount: function() {
      this.$store.dispatch("getAllMembers", {
        criterias: this.campaign.searchCriterias
      });
    },
    headers: function() {
      let headers = [
        { prop: "email", label: L.localize("Label_EmailAddress") }
      ];
      return headers;
    }
  }
};
</script>

<style lang='scss'>
</style>



// WEBPACK FOOTER //
// CampaignTarget.vue?2468a914